/**
 * Supported setting types for application provisioning settings.
 * This check the type of request type setting object to see if it is supported.
 */
export const SupportedSettingTypes = {
  SingleSelect: 'dropdownSingle',
  MultiSelect: 'dropdownMulti',
  Checkbox: 'checkbox',
  Text: 'text',
  Email: 'email',
} as const;

type SupportedSettingTypesType =
  (typeof SupportedSettingTypes)[keyof typeof SupportedSettingTypes];

/**
 * Type‑guard: returns true if `u` is one of the const values.
 */
export function isSupportedSettingTypes(
  u: unknown
): u is SupportedSettingTypesType {
  return (
    typeof u === 'string' &&
    Object.values(SupportedSettingTypes).includes(
      u as SupportedSettingTypesType
    )
  );
}
